<template>
    <Modal :modal-title="title"
           :dialog="incidentStatusFormVisibility"
           max-width="500px"
           :persistent="true"
           :closeIcon="false"
           dense
           data-test="modal"
           @keydown.enter="showConfirmation"
           @keydown.esc="closeWithConfirmation"
           @close="close"
           @visibility="visibility($event)">
        <template slot="content">
            <ManageIncidentStatusForm ref="form"
                            :is-editable="isEditable"></ManageIncidentStatusForm>
            <ConfirmationDialog :dialog="showConfirmationDialog"
                                data-test="ConfirmationDialog"
                                @confirm="handleConfirmation($event)"
                                :text="$t('messages.save_changes')"
                                :action-button-title="$t('buttons.save')"></ConfirmationDialog>

            <span data-test="testKeydownSpan"></span>

            <ValidationError v-if="showError"></ValidationError>
        </template>
        <template slot="actions">
            <v-layout align-center
                      justify-end
                      class="mt-3">
                <v-btn color="secondary"
                       outlined
                       class="mr-3"
                       data-test="closeBtn"
                       @click="close">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn color="secondary"
                       data-test="saveBtn"
                       :loading="loader"
                       :disabled="loader"
                       @click="save">{{ $t('buttons.save') }}</v-btn>
            </v-layout>
        </template>
    </Modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/templates/Modal';
import ManageIncidentStatusForm from '@/components/incidentsStatuses/ManageIncidentStatusForm';
import ValidationError from '@/components/widgets/ValidationError';
import ConfirmationDialog from '@/components/widgets/dialogs/ConfirmationDialog';

export default {
    name: 'ManageIncidentStatus',
    components: { Modal, ManageIncidentStatusForm, ValidationError, ConfirmationDialog },
    data: () => ({
        showConfirmationDialog: false,
        loader: false,
        showError: false
    }),
    computed: {
        ...mapState('manageIncident', [
            'incidentStatusFormVisibility',
            'editedIncidentStatusId'
        ]),
        isFieldsDirty () {
            return this.$refs.form.isFormDirty;
        },
        title () {
            return this.isEditable ? this.$t('buttons.edit') : this.$t('buttons.add');
        },
        isEditable () {
            return this.editedIncidentStatusId !== null && this.editedIncidentStatusId !== undefined;
        }
    },
    methods: {
        close () {
            this.$store.commit('manageIncident/SET_STATUS_FORM_VISIBILITY', false);
            this.$refs.form.resetValidation();
            // prevent showing bad data 0.1s
            setTimeout(() => {
                this.$store.commit('manageIncident/CLEAR_INCIDENT_STATUS_DATA');
            }, 100);
            this.$emit('fetch');
        },
        visibility (event) {
            this.$store.commit('manageIncident/SET_STATUS_FORM_VISIBILITY', event);
        },
        closeWithConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            } else {
                this.close();
            }
        },
        showConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            }
        },
        createStatus () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('manageIncident/createIncidentStatus')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        updateStatus () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('manageIncident/updateIncidentStatus')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        save () {
            if (this.isEditable) {
                this.updateStatus();
            } else {
                this.createStatus();
            }
        },
        handleConfirmation (event) {
            if (event) {
                this.save();
                this.showConfirmationDialog = false;
            } else {
                this.showConfirmationDialog = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
